export default "/images/harnois-logo.svg?fea2b20be4f48592fec25947582cc0c5";